var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacOs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qobnvrhqqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v1641H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ust4qexvb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.697 0 12 5.304 12 12 0 6.697-5.304 12-12 12S0 18.697 0 12C0 5.304 5.304 0 12 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nn9216ojtd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.132 0c.154 0 .293.02.418.058.125.04.232.095.32.167a.742.742 0 0 1 .277.602v1.736h-.481V2.14h-.013a.76.76 0 0 1-.136.185.873.873 0 0 1-.412.23 1.06 1.06 0 0 1-.596-.023.797.797 0 0 1-.27-.15.68.68 0 0 1-.176-.237A.735.735 0 0 1 0 1.837c0-.222.083-.395.248-.52.165-.125.405-.198.719-.218l.682-.04V.864c0-.146-.046-.257-.138-.333-.093-.076-.224-.114-.393-.114a.7.7 0 0 0-.192.025.526.526 0 0 0-.156.074.42.42 0 0 0-.172.262H.125a.672.672 0 0 1 .083-.31A.799.799 0 0 1 .42.221C.51.151.614.097.736.058.857.02.989 0 1.132 0zm.517 1.415-.614.042c-.174.01-.305.048-.393.11a.304.304 0 0 0-.132.262c0 .109.043.196.13.26a.571.571 0 0 0 .35.096c.093 0 .18-.014.26-.042a.649.649 0 0 0 .21-.12.534.534 0 0 0 .19-.41v-.198z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wd22onh2ye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99 0C4.584 0 5.7.916 5.741 2.233H4.655C4.58 1.441 3.932.953 2.967.953c-.959 0-1.622.493-1.622 1.205 0 .562.417.895 1.435 1.152l.836.208c1.59.386 2.244 1.013 2.244 2.138 0 1.435-1.136 2.33-2.946 2.33C1.227 7.986.08 7.102 0 5.715h1.098c.086.793.852 1.318 1.902 1.318 1.007 0 1.73-.525 1.73-1.243 0-.621-.44-.996-1.457-1.253l-.991-.246C.857 3.937.209 3.289.209 2.223.21.911 1.356 0 2.99 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rkqbt7okif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.723 0a.92.92 0 0 1 .34.06.73.73 0 0 1 .427.43.969.969 0 0 1 .058.344v1.724h-.503V.955c0-.166-.043-.295-.129-.386C2.831.48 2.71.433 2.551.433a.546.546 0 0 0-.213.04.487.487 0 0 0-.276.29.611.611 0 0 0-.04.225v1.57h-.496V.913A.55.55 0 0 0 1.49.715a.42.42 0 0 0-.25-.248.57.57 0 0 0-.416.01.509.509 0 0 0-.28.3c-.026.07-.068.147-.068.229v1.551H0V.027h.482v.43C.522.384.56.32.607.264a.722.722 0 0 1 .37-.234A.873.873 0 0 1 1.211 0c.177 0 .326.042.448.127a.68.68 0 0 1 .26.364h.012a.759.759 0 0 1 .127-.205.819.819 0 0 1 .407-.252A.96.96 0 0 1 2.723 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4hdd4nibeg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 0C5.81 0 7.193 1.542 7.193 3.996c0 2.452-1.383 3.99-3.595 3.99S0 6.449 0 3.996C0 1.542 1.387 0 3.6 0zm0 .985c-1.516 0-2.464 1.162-2.464 3.01C1.136 5.837 2.084 7 3.599 7 5.11 7 6.063 5.837 6.063 3.995c0-1.848-.953-3.01-2.464-3.01z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rtsmkqi39h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.184 0c.162 0 .308.024.437.072.13.048.241.113.334.195a.928.928 0 0 1 .32.63h-.482A.62.62 0 0 0 1.727.71a.509.509 0 0 0-.123-.149.579.579 0 0 0-.18-.099.704.704 0 0 0-.513.026.614.614 0 0 0-.213.175.827.827 0 0 0-.137.274 1.23 1.23 0 0 0-.05.36c0 .137.017.26.05.367a.792.792 0 0 0 .139.273.6.6 0 0 0 .216.172c.083.039.176.06.277.06a.657.657 0 0 0 .403-.117.543.543 0 0 0 .202-.34h.482a.93.93 0 0 1-.338.639 1.022 1.022 0 0 1-.332.178 1.342 1.342 0 0 1-.42.063c-.18 0-.342-.03-.488-.09a1.051 1.051 0 0 1-.376-.257 1.152 1.152 0 0 1-.241-.408A1.612 1.612 0 0 1 0 1.297 1.56 1.56 0 0 1 .084.763a1.19 1.19 0 0 1 .24-.41C.427.242.552.154.697.093.843.03 1.006 0 1.184 0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4oqjlhl3wc",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7",
    offset: "59.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qobnvrhqqa)",
    transform: "translate(-478 -424)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ust4qexvb)",
    transform: "translate(478 424)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#4oqjlhl3wc)",
    d: "M0 0h24v24H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nn9216ojtd)",
    transform: "translate(489.56 429.929)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#515050",
    d: "M0 0h2.147v2.588H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wd22onh2ye)",
    transform: "translate(490.934 434.085)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#515050",
    d: "M0 0h5.86v7.986H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rkqbt7okif)",
    transform: "translate(485.475 429.934)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#515050",
    d: "M0 0h3.548v2.558H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4hdd4nibeg)",
    transform: "translate(482.97 434.085)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#515050",
    d: "M0 0h7.194v7.986H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rtsmkqi39h)",
    transform: "translate(492.246 429.929)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#515050",
    d: "M0 0h2.28v2.592H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOs);
export default __webpack_public_path__ + "static/media/macOs.9ebafb845a23d5f25c7bc644e398c33f.svg";
export { ForwardRef as ReactComponent };